const constants = {
    baseUrl: "https://pconprod.wagner-living.de/",
    zoomInButtonValue: -0.15,
    zoomOutButtonValue: 0.15,
    anchor: "#configurator",
}

export default constants;